export const GET_CLIENT_FILES = 'sharedFile/GET_CLIENT';
export const GET_CLIENT_FILES_SUCCESS = 'sharedFile/GET_CLIENT_SUCCESS';
export const GET_CLIENT_FILES_ERROR = 'sharedFile/GET_CLIENT_ERROR';

export const UPLOAD_CLIENT_FILE = 'sharedFile/UPLOAD';
export const UPLOAD_CLIENT_FILE_SUCCESS = 'sharedFile/UPLOAD_SUCCESS';
export const UPLOAD_CLIENT_FILE_ERROR = 'sharedFile/UPLOAD_ERROR';

export const DELETE_CLIENT_FILE = 'sharedFile/DELETE';
export const DELETE_CLIENT_FILE_SUCCESS = 'sharedFile/DELETE_SUCCESS';
export const DELETE_CLIENT_FILE_ERROR = 'sharedFile/DELETE_ERROR';
